import { ExpansionTemplateInfo } from './Contexts';
import { DragInterfaceContext } from './MouseDragProvider';

import LayoutValueImage from './LayoutValueImage';
import { NodeDisplayContext, GridCellContext, ExpansionWindowFocusContext } from './Contexts'; 
import { useContext, useMemo, useRef, useState } from 'react';
import React from 'react';

const FILTER_CLASS_MAP = {
  //"012":"rgb-channel",
  "01":"red-green-channel",
  "02":"red-blue-channel",
  "12":"green-blue-channel",
  "0":"red-channel",
  "1":"green-channel",
  "2":"blue-channel"
}

/*

Need to paint the drawn / extra regions.
There's also a layer for arrows, etc.
Labels, in general.

Is this the region where we'd be painting the outlines.
If so (i.e, it's MAIN region), then we look to see what other regions there are.


Then, barring overrides, we just paint everything down.
And by default we paint, we may not even have 

*/





function BaseLayoutValue({
  value, 
  regions, 
  node, 
  nodeId, 
  nodes, 
  parentPixelDimensions ,
  computedDimensions,
}){
  let { 
    channels,
    regionId,
  } = value;



  const dragInterface = useContext(DragInterfaceContext);

  let cellLocation = useContext(GridCellContext);

  let nodeDisplayContext = useContext(NodeDisplayContext);

  //let computedDimensions = useContext(ExpansionTemplateInfo);

  let nodeDims = computedDimensions?.[nodeId] || { w:1, h: 1};


  let { style } = node;
  let { padding=0, borderWidth=0, borderColor='white' } = style || {};



   let { selectedNodes, onEvent } = useContext(ExpansionWindowFocusContext);


  let annotationId = regions[regionId];
  let children = node.c;
  
  let selectedItemCover;

  let isSelected = selectedNodes?.find((item) => {
    let thatNodeId = item.nodeId;
    let thatNode = item;

    let strNodeCL = JSON.stringify(thatNode.cellLocation);
    let strCL = JSON.stringify(cellLocation);

    if( nodeId === "012-text-0" ){
    }
    return thatNodeId === nodeId &&  strNodeCL === strCL;
  })


  if( isSelected ){
    selectedItemCover = <div style={{zIndex:100,color:'white', fontWeight:'bold', pointerEvents:'none'}} class="selected-item-cover"/>
  }

  //nodeId.includes('012') && ;

  let onSomeClick = (e) => {

    console.log("BaseLayoutValue click");
    

    //if( dragInterface.getDragInfo() ){ return; }


    e.stopPropagation();
    e.preventDefault();


    onEvent && onEvent({
      type:"click",
      itemType:"expansionNode",
      node,
      event:e,
      nodeId,
    })
  }

  let width = nodeDims.w - padding *2;
  let height = nodeDims.h - padding * 2;


  let nodeDisplayOverride = nodeDisplayContext?.nodeDisplay?.({node});

  if( nodeDisplayOverride !== undefined ){
    return nodeDisplayOverride;
  }


  let content = (
    <LayoutValueImage {...{
        annotationId,
        style:{
          outline:`${Math.min(style?.borderWidth,style?.padding)}px solid ${style?.borderColor}`
        },
        node,
        regionId,
        regions, children, 
        selectedNodes, 
        nodes, 
        onEvent, nodeId, 
        parentPixelDimensions:{ w:width, h:height }, 
      }}/>
  )

  return (
    <div layer={"outer"} nodeId={nodeId} style={{
      position:"relative",
      pointerEvents:'auto',
      width,
      height,
      padding,
    }} 

     
      onMouseDown={e => {

        e.stopPropagation();
        e.preventDefault();


      }}

      onClickCapture={e => { }}
      onContextMenu={onSomeClick}
      onClick={onSomeClick}
      //onClick={e => { e.stopPropagation(); }}
    >

      

      {content}


      {selectedItemCover}

      {false && nodeDisplayContext?.nodeDecoration?.({nodeId,node,caller:"BaseLayoutValue",
        content,
      })}
      

    </div>
  )
}

export default React.memo(BaseLayoutValue);
